import { StyleSheet } from 'react-native';

import { PALETTE } from '../../../constants';

export default StyleSheet.create({
  root: {
    display: 'flex',
  },
  container: {
    backgroundColor: 'transparent',
    flexDirection: 'row',
  },
  leftContainer: {
    alignSelf: 'flex-start',
  },
  rightContainer: {
    alignSelf: 'flex-end',
  },
  centerContainer: {
    alignSelf: 'center',
  },
  justifyContainer: {
    display: 'flex',
  },
  option: {
    display: 'flex',
    flexGrow: 1,
  },
  labelBase: {
    color: PALETTE.secondaryText,
    textAlign: 'center',
    marginBottom: 5,
    fontSize: 16
  },
  labelActive: {
    color: PALETTE.primaryText,
  },
  labelDisabled: {
    color: '#444',
  },
  indicatorBase: {
    height: 2,
    backgroundColor: 'rgba(0,0,0,0.5)', // TODO palettise
  },
  indicatorActive: {
    backgroundColor: PALETTE.primaryActive,
    // shadowColor: PALETTE.primaryActive ,
    shadowOpacity: 0.75,
    shadowRadius: 3,
    shadowOffset: { width: 0, height: 0 },
  },
});
